export default "__VITE_ASSET__a99961d7__"